import React from "react";
import { renderToString } from "react-dom/server";
import axios from "axios";
import { connect } from "react-redux";
import { FormControl, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { withStyles } from "tss-react/mui";
import {
  AccessTime,
  CheckCircle,
  Lock,
  Loop,
  LowPriority,
  Payment,
  QueryBuilder,
  Replay,
  ShoppingBasket,
  Visibility,
  Warning,
} from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Detail from "./Modals/Detail";
import PaymentDetails from "./Modals/PaymentDetails";
import { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import OrderValueFilter from "../../components/Filters/OrderValueFilter";
import OrderStatusTypeFilter from "../../components/Filters/OrderStatusTypeFilter";
import OrderStatusFilter from "../../components/Filters/OrderStatusFilter";
import BetaaldStatusFilter from "../../components/Filters/BetaaldStatusFilter";
import TextFilter from "../../components/Filters/TextFilter";
import OrderDateFilter from "../../components/Filters/OrderDateFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import ApiStatusFilter from "../../components/Filters/ApiStatusFilter";
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

class Index extends React.Component {
  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.getData();
  };

  constructor(props) {
    super(props);

    /**
     * Handle Filters
     */
    this.state = {
      detailModal: false,
      selectedId: null,
      detailPaymentsModal: false,
      zFromCreatedAtUnix: null,
      zToCreatedAtUnix: null,
    };
  }

  /**
   * Get financial format
   */
  getNumberformat(value, currency = "EUR") {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency.toUpperCase(),
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDetailAction = (row) => {
    let id = row[0].replace(/<b>([0-9]+)<\/b>.*/ims, "$1");
    this.setState({
      selectedId: id,
      detailModal: true,
    });
  };

  handleDetailPaymentsAction = (rowData) => {
    let id = rowData.id;
    this.setState({
      selectedId: id,
      detailPaymentsModal: true,
    });
  };

  handleRetry = (row) => {
    let status = renderToString(row[3])
      .replace(/.*<br\/>(.*)/ims, "$1")
      .replace(/<[^>]+><[^>]+>([^<]+).*/ims, "$1")
      .toLowerCase();
    let id = row[0].replace(/<b>([0-9]+)<\/b>.*/ims, "$1");
    let apiStatus = parseInt(
      renderToString(row[3])
        .replace(/(.*)<br\/>.*/ims, "$1")
        .replace(/.*<span[^>]+>(.*)<\/span>/ims, "$1")
    );
    if (!apiStatus && status != "queued") {
      status = "Unknown";
    }
    switch (status) {
      case "ok":
        /**
         * Doen we niet
         */
        alert("This order is already processed");
        break;
      default:
        /**
         * Retry order ...
         */
        axios.get("../core/orderexchange/" + id + "?force=1").then((response) => {
          if (response.data.orderStatus) {
            alert("Order sent to pos");
          } else {
            alert("Order failed");
          }
        });
        break;
    }
  };

  //Data formaters tabel
  handleCustomDatumVestiging = (item) => {
    const createdAt = new Date(item.aangemaakt);
    const tableValue = item.table !== null ? item.table.naam : item.tafel_id + " (ID)";
    // return tableValue + "<br />" + item.total_items;
    return (
      (item?.vestiging?.timezone && item?.vestiging?.timezone != "Europe/Amsterdam"
        ? "<span style='color: darkred; font-weight: bold;' title='" +
          format(createdAt, "dd-MM-yy HH:mm:ss") +
          "'>" +
          formatInTimeZone(createdAt, item.vestiging.timezone, "dd-MM-yy HH:mm:ss") +
          "</span>"
        : format(createdAt, "dd-MM-yy HH:mm:ss")) +
      " / <b>" +
      tableValue +
      "</b><br />" +
      (item.vestiging ? item.vestiging.systeemNaam : "")
    );
  };

  //Data formaters tabel
  LRCCLNotification = (item) => {
    let build = "";
    let platform = null;
    if (item?.metadata?.sessiondata) {
      let sessionVars = JSON.parse(item?.metadata?.sessiondata);
      if (sessionVars?.platform) {
        switch (sessionVars?.platform) {
          case "https://jamezz.app/":
            platform = "S";
            break;
          case "https://qrv5.jamezz.app/":
            platform = "S";
            break;
          case "https://kioskv5.jamezz.app/":
            platform = "S";
            break;
          case "https://rc.jamezz.app/":
            platform = "R";
            break;
          case "https://staging.jamezz.app/":
            platform = "T";
            break;
          case "https://alpha.jamezz.app/":
            platform = "A";
            break;
          case "http://jamezzv2.test/":
            platform = "D";
            break;
          case "https://jamezzv2.test/":
            platform = "D";
            break;
        }
      }

      if (sessionVars?.build) {
        let buildDate = new Date(sessionVars?.build);
        build = "F(" + buildDate.toISOString().substring(2, 16) + (platform ? "-" + platform : "") + ")";
        console.log(build);
      } else {
        build = platform ? "(" + platform + ")" : "";
      }
    }
    let oStatus = item.last_apilog ? item.last_apilog.resultmsg : "";
    let appVersion = "v3";
    if (item.callback_status != 10 || item.callback_status != 1) {
      switch (item.callback_status) {
        case 100:
          oStatus = (
            <span style={{ color: "#00a000" }}>
              <b>Waiting on callback</b>
            </span>
          );
          break;
        case 0:
          oStatus = (
            <span style={{ color: "#ff0000" }}>
              <b>Callback failed</b>
            </span>
          );
          break;
      }
    } else {
      switch (parseInt(item.queued)) {
        case 1:
          oStatus = (
            <span style={{ color: "#00a000" }}>
              <b>QUEUED {item.timeSlot ? "(" + new Date(item.timeSlot).toLocaleString() + ")" : ""}</b>
            </span>
          );
          break;
        case 2:
          oStatus = (
            <span style={{ color: "#ff0000" }}>
              <b>QUEUE FAILED</b>
            </span>
          );
          break;
        case 99:
          oStatus = (
            <span style={{ color: "#8080ff" }}>
              <b>AD QUEUED</b>
            </span>
          );
          break;
      }
    }

    switch (item.vestiging.appTarget) {
      case "appv5.js":
        appVersion = "v5";
        break;
      case "app.js":
        appVersion = "v3";
        break;
      case "app_lite.js":
        appVersion = "v4";
        break;
      case "app_kioskv2.js":
        appVersion = "Kiosk v2";
        break;
      case "app_meyer.js":
      case "app_woktogo.js":
        appVersion = "Custom";
        break;
      default:
        appVersion = "Removed";
        break;
    }
    return (
      <div>
        <b>{item.vestiging.apiProvider !== "JAMEZZ" ? item.retryCount : 1}</b> /{" "}
        {item.lock ? (
          <Loop style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
        ) : (
          <CheckCircle style={{ color: "green", width: "18px", position: "relative", top: "7px" }} />
        )}{" "}
        /{" "}
        {item.closed || (item.vestiging.apiProvider == "JAMEZZ" && item.is_betaald) ? (
          <Lock style={{ color: "green", width: "18px", position: "relative", top: "5px" }} />
        ) : (
          <CheckCircle style={{ color: "green", width: "18px", position: "relative", top: "7px" }} />
        )}{" "}
        /{" "}
        {item.queued && !item.apiStatus ? (
          <LowPriority style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
        ) : (
          <CheckCircle style={{ color: "green", width: "18px", position: "relative", top: "7px" }} />
        )}{" "}
        /{" "}
        {!item.apiStatus ? (
          <AccessTime style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
        ) : (
          <CheckCircle style={{ color: "green", width: "18px", position: "relative", top: "7px" }} />
        )}
        <span style={{ display: "none" }}>{item.apiStatus}</span>
        <br />
        {item.apiStatus >= 1 ? (
          <span>
            {item.apiStatus}
            <b> ms</b>
          </span>
        ) : (
          oStatus
        )}{" "}
        /{" "}
        <Tooltip title={build}>
          <b>
            {appVersion} ({platform})
          </b>
        </Tooltip>
      </div>
    );
  };

  orderStatusPayValue = (item) => {
    let value = 0;
    let psp = "";
    if (item.payProvider !== undefined && item.payProvider != null) {
      psp = " (<i>" + item.payProvider + (item.payMethod ? ", " + item.payMethod : "") + "</i>)";
    }
    value = item.order_value;
    return (
      item.is_betaald +
      " / " +
      item.status +
      " / " +
      item.total_items +
      " / #" +
      item.oCnt +
      (item.parent_id ? " / PO" + item.parent_id : "") +
      "<br /><b>" +
      this.getNumberformat(value, item.vestiging?.valuta) +
      "</b>" +
      psp
    );
  };

  jamezzPayments = (item) => {
    if (item.payProvider != "CM" && item.payProvider != "MOLLIE" && item.payProvider != "PAYNL") {
      return (
        <div>
          <Warning style={{ color: "#fc5203", width: "18px", position: "relative", top: "7px" }} /> Get Jamezz Payments
        </div>
      );
    } else {
      let displayKey = item.transKey ?? item.transid;
      let transFree = null;
      switch (item.payProvider) {
        case "CM":
          break;
        case "MOLLIE":
          if (item.transdata !== undefined && item.transdata) {
            let paymentData = JSON.parse(item.transdata);
            if (paymentData.applicationFee !== undefined && paymentData.applicationFee) {
              transFree = this.getNumberformat(
                paymentData.applicationFee.amount.value ?? 0,
                paymentData.applicationFee.amount.currency ?? "EUR"
              );
            }
          }
          break;
        case "PAYNL":
          if (item.custom_data && item.custom_data.transactionFee !== undefined && item.custom_data.transactionFee) {
            transFree = this.getNumberformat(
              item.custom_data.transactionFee.amount ?? 0,
              item.custom_data.transactionFee.currency ?? "EUR"
            );
          }
          break;
      }

      return (
        <div>
          {displayKey.substr(0, 16)}... /{" "}
          <Payment
            onClick={(e) => {
              this.handleDetailPaymentsAction(item);
            }}
            style={{ color: "green", width: "18px", position: "relative", top: "7px", cursor: "pointer" }}
          />
          <br />
          <div style={{ display: "inline-block", marginRight: "3px" }}>
            <AuthenticationWrapper permissionKey={"bestellingen.displayTransactionFee"}>
              {transFree ? (
                <b>
                  {transFree}
                  {" / "}
                </b>
              ) : null}
            </AuthenticationWrapper>
          </div>
          {item.payout ? (
            <CheckCircle style={{ color: "green", width: "18px", position: "relative", top: "7px" }} />
          ) : (
            <QueryBuilder style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
          )}{" "}
          /{" "}
          {item.chargeback ? (
            <Warning style={{ color: "#fc5203", width: "18px", position: "relative", top: "7px" }} />
          ) : (
            <CheckCircle style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
          )}{" "}
          /{" "}
          {item.refunded ? (
            <Warning style={{ color: "#fc5203", width: "18px", position: "relative", top: "7px" }} />
          ) : (
            <CheckCircle style={{ color: "gray", width: "18px", position: "relative", top: "7px" }} />
          )}
        </div>
      );
    }
  };

  orderId = (item) => {
    return "<b>" + item.id + "</b><br /><i>" + item.vestiging?.apiProvider + "</i>";
  };

  rowColor = (item) => {
    if (((item.callback_status != 10 || item.callback_status != 1) && !item.apiStatus) || item.queueStatus == 80) {
      if (item.queueStatus == 80) {
        return {
          backgroundColor: "#ffef7950",
        };
      } else {
        switch (item.callback_status) {
          case 100:
            return {
              backgroundColor: "#ffef7950",
            };
            break;
          case 0:
            return {
              backgroundColor: "#ffc5c56d",
            };
            break;
        }
      }
    } else {
      return {
        backgroundColor:
          item.queued && !item.apiStatus && item.vestiging?.apiProvider !== "JAMEZZ"
            ? "#e2ecff6d"
            : (item.retryCount > 1 &&
                  !item.apiStatus &&
                  item.vestiging?.queueorders &&
                  item.vestiging?.apiProvider !== "JAMEZZ") ||
                (item.retryCount <= 1 &&
                  !item.apiStatus &&
                  !item.vestiging?.queueorders &&
                  item.vestiging?.apiProvider !== "JAMEZZ")
              ? "#ffc5c56d"
              : null,
      };
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={getTranslation("bestellingen.pagetitle", "Bestelling overzicht")} />
        <AuthenticationWrapper permissionKey={"bestellingen.status"}>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <OrderValueFilter />
              </FormControl>
            </GridItem>
            <GridItem sm={2} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <OrderStatusTypeFilter />
              </FormControl>
            </GridItem>
            <GridItem sm={2} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <OrderStatusFilter />
              </FormControl>
            </GridItem>
            <GridItem sm={2} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <BetaaldStatusFilter />
              </FormControl>
            </GridItem>
            <GridItem sm={2} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <ApiStatusFilter />
              </FormControl>
            </GridItem>
          </GridContainer>
        </AuthenticationWrapper>
        <GridContainer>
          <VestigingenFilter />
          <GridItem md={2} xs={12}>
            <TextFilter
              field={"id"}
              fieldKey={"order_id"}
              placeholder={getTranslation("bestellingen.filter.orderid", "Bestel nummer")}
            />
          </GridItem>
          <GridItem md={2} xs={12}>
            <TextFilter
              field={"table.naam"}
              fieldKey={"order:table.naam"}
              operator={"naturalsort"}
              placeholder={getTranslation("Table number")}
            />
          </GridItem>
          <GridItem md={2} xs={12}>
            <TextFilter
              field={"metadata.orderValue"}
              fieldKey={"order:metadata.orderValue"}
              onParseValue={(value) => {
                return value.replace(",", ".");
              }}
              placeholder={getTranslation("Order amount")}
            />
          </GridItem>
        </GridContainer>
        <OrderDateFilter />
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Visibility,
                  tooltip: getTranslation("tafels.bestellingen.tooltip.showOrder", "Show order"),
                  action: this.handleDetailAction,
                },
                {
                  icon: Replay,
                  tooltip: getTranslation("tafels.bestellingen.tooltip.retryOrder", "Retry order"),
                  action: this.handleRetry,
                },
              ]}
              dataMapping={[
                { customData: this.orderId },
                { customData: this.handleCustomDatumVestiging },
                { customData: this.orderStatusPayValue },
                { customData: this.LRCCLNotification },
                { customData: this.jamezzPayments },
              ]}
              dbfields={
                "id,vestiging.apiProvider,callback_status,queueStatus,callback_time,vestiging.timezone,vestiging.appTarget,vestiging.queueorders,metadata.orderid,metadata.sessiondata,parent_id,aangemaakt,custom_data,transdata,transid,timeSlot,apiStatus,is_betaald,queued,status,lock,retryCount,closed,oCnt,vestiging.id,vestiging.systeemNaam,vestiging.valuta,vestiging_id,lastApilog.id,lastApilog.bestelling_id,lastApilog.resultmsg,lastApilog.ts,table.id,table.naam,tafel_id,payProvider,payMethod,transKey,refunded,payout,chargeback,parent_id"
              }
              fetchUrl={"core/bestellingen"}
              filters={this.props.filters}
              headerIcon={<ShoppingBasket />}
              headers={[
                {
                  label:
                    getTranslation("bestellingen.table.id", "#") +
                    "<br />" +
                    getTranslation("bestellingen.table.apiProvider", "API"),
                  sortKey: "id",
                },
                {
                  label:
                    getTranslation("bestellingen.table.datum", "Datum") +
                    " / " +
                    getTranslation("bestellingen.table.tafel", "Tafel") +
                    "<br />" +
                    getTranslation("bestellingen.table.vestiging", "Vestiging"),
                  sortable: true,
                  sortKey: "aangemaakt",
                },
                {
                  label:
                    getTranslation("bestellingen.table.betaald", "Betaald") +
                    " / " +
                    getTranslation("bestellingen.table.status", "Status") +
                    " / " +
                    getTranslation("bestellingen.table.item_count", "Items") +
                    " / " +
                    getTranslation("bestellingen.table.ocnt", "#") +
                    "<br />" +
                    getTranslation("bestellingen.table.ordervalue", "Ordervalue"),
                  sortable: false,
                },
                {
                  label:
                    getTranslation("bestellingen.table.lockRetryCountClosed", "RC / L /  CL / Q / A") +
                    "<br />" +
                    getTranslation("bestellingen.table.melding", "API Time / Melding"),
                  sortable: false,
                },
                {
                  label:
                    "<table><tr><td><img src='/img/jamezzPayments.png' style='width: 75px; margin-top: 0px' /></td><td>" +
                    getTranslation("bestellingen.table.transid", "Transaction #") +
                    " / " +
                    getTranslation("bestellingen.table.paymentinfo", "Info") +
                    "<br />" +
                    getTranslation("bestellingen.table.payout", "Paid") +
                    " / " +
                    getTranslation("bestellingen.table.Chargeback", "ChargeBack") +
                    " / " +
                    getTranslation("bestellingen.table.refunded", "Refund") +
                    "</td></tr></table>",
                  sortable: false,
                },
              ]}
              reduxKey={"bestellingen"}
              ref={this.jamezzTable}
              rowConditionalStyle={this.rowColor}
              showAutoRenew
              showRefresh
              tableTitle={getTranslation("bestellingen.table.titel", "Bestellingen overzicht")}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        <Detail
          bestellingId={this.state.selectedId}
          open={this.state.detailModal}
          toggle={() => this.toggleModal("detailModal")}
        />
        <PaymentDetails
          bestellingId={this.state.selectedId}
          open={this.state.detailPaymentsModal}
          refreshJamezzTable={this.refreshJamezzTable.bind(this)}
          toggle={() => this.toggleModal("detailPaymentsModal")}
        />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);

  if (state.filtersV2["metadata.orderValue"]) {
    filters["metadata.orderValue"] = state.filtersV2["metadata.orderValue"];
  }
  if (state.filtersV2["queued"]) {
    filters["queued"] = state.filtersV2["queued"];
  }
  if (state.filtersV2["status"]) {
    filters["status"] = state.filtersV2["status"];
  }
  if (state.filtersV2["is_betaald"]) {
    filters["is_betaald"] = state.filtersV2["is_betaald"];
  }
  if (state.filtersV2["apiStatus"]) {
    filters["apiStatus"] = state.filtersV2["apiStatus"];
  }
  if (state.filtersV2["order_id"]) {
    filters["order_id"] = state.filtersV2["order_id"];
  }
  if (state.filtersV2["order:table.naam"]) {
    filters["order:table.naam"] = state.filtersV2["order:table.naam"];
  }
  if (state.filtersV2["order:metadata.orderValue"]) {
    filters["order:metadata.orderValue"] = state.filtersV2["order:metadata.orderValue"];
  }
  if (state.filtersV2["order:fromAangemaakt"]) {
    filters["order:fromAangemaakt"] = state.filtersV2["order:fromAangemaakt"];
  }
  if (state.filtersV2["order:toAangemaakt"]) {
    filters["order:toAangemaakt"] = state.filtersV2["order:toAangemaakt"];
  }
  return {
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, productenStyle));
